import { Grid } from 'semantic-ui-react'
import { useNavigate } from 'react-router-dom'
import { FEATURE_FLAG_KEYS } from '@/v2-features/open-feature'
import { useBooleanFlagValue } from '@openfeature/react-sdk'

import { useFetchResponse, useReselector } from '@/utils/sharedHooks'
import { Alert, Button, Text } from '@/componentsV1/BaseComponents'
import { userGetBookkeepingSubmission } from '@/features/bookkeeping/end-of-year-review/actions'
import { EndOfYearSubmissionStatus } from '@/features/bookkeeping/end-of-year-review/types'
import { selectDeadlineBannerCopy } from '../annualTaxFilings.selector'

export const DeadlineBanner = () => {
  const navigate = useNavigate()
  const deadlineBannerCopy = useReselector(selectDeadlineBannerCopy)

  const submission = useFetchResponse(userGetBookkeepingSubmission)
  const deadlineBannerEnabled = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableTaxDeadlineBanner,
    false
  )

  if (
    submission?.status === EndOfYearSubmissionStatus.waitingOnHeard ||
    !deadlineBannerCopy ||
    !deadlineBannerEnabled // If deadline banner is disabled, don't show the banner
  ) {
    return null
  }

  return (
    <Alert type="warn">
      <Grid>
        <Grid.Row>
          <Grid.Column
            width={12}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Text>{deadlineBannerCopy.bannerCopy}</Text>
          </Grid.Column>
          <Grid.Column width={4}>
            <Button
              variant="secondaryLink"
              onClick={() => navigate('/taxes/annual')}
            >
              {deadlineBannerCopy.buttonCopy}
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Alert>
  )
}
